































































































































import Vue from 'vue';
import * as validation from '@/personal/validation';
import * as NOCArray from '@/personal/array';
import { ISelectOption as iso } from '@/class/models/typed/wild';
import { strFuzzyMatch } from '@/class/common/util';
import SearchResult from '@/components/util/SearchResult.vue';
import SelectBox from '@/components/util/NewSelectBox.vue';
import ClickOutside from 'vue-click-outside';
import { INPUT_TYPE } from './input_type';

export interface INewVariableInput extends validation.IPValidation {
  type: INPUT_TYPE
  disabled?: boolean;
  class?: string;
  step?: number;
}

export const checkValue = validation.checkValue;
export const checkValues = validation.checkValues;
export const CHECK_TYPE = validation.CHECK_TYPE;

export default Vue.extend({
  name: 'NewVariableInput',
  components: {
    SelectBox, SearchResult,
  },
  directives: {
    ClickOutside,
  },
  props: ['value', 'item', 'mode', 'isShowResend', 'visiibleOnlyValues'],
  data() {
    return {
      data: '',
      // search用
      searchText: '',
      excludeList: [] as iso[],
      selectList: [] as number[],
      hoverJobIndex: -1,
      selectorshow: false,
      /*
      options: [
        {checked: true, text: '山田太郎', id: 1},
        {checked: true, text: 'その他', id: 2},
        {checked: false, text: 'エンジニア', id: 3},
        {checked: false, text: 'デザイナー', id: 4},
        {checked: false, text: '内勤', id: 5},
        {checked: false, text: '外勤', id: 6},
        {checked: false, text: '総務・採用', id: 7},
      ],
      */
    };
  },
  created() {
    if (this.item.type === 'search') {
      this.$watch('value', () => {
        if (this.value) {
          this.excludeList = [ ...this.value ];
          this.selectList = [];
        } else {
          this.excludeList = [];
          this.selectList = [];
        }
      });
    }
  },
  mounted() {
    this.item.error = '';
    // RichSelectBox
    if (this.item.type === 'search' && this.value) {
      this.excludeList = [ ...this.value ];
      this.selectList = [];
    } else {
      this.excludeList = [];
      this.selectList = [];
    }
  },
  computed: {
    getOptionsText() {
      return NOCArray.getOptionsText;
    },
    OPTIONS(): iso[] {
      if (this.item.type === 'search' && this.item.options) {
        const rOptions = this.item.options.filter((v: iso) => !this.excludeList.some((v2) => v.value === v2.value)) ;
        // 一致するものは選択肢として表示しない
        return this.visiibleOnlyValues ? 
          rOptions.filter((rOption: iso) => this.visiibleOnlyValues.indexOf(rOption.text) < 0)
          : rOptions;
      } else {
        return [];
      }
    },
  },
  methods: {
    onInput(value: any) {
      this.$emit('input', value);
    },
    onRadioInput(value: string) {
      this.$emit('input', Number(value));
    },
    onChange(value: any) {
      validation.checkValue(value, this.item);
    },
    onSelectChange(value: any) {
      this.$emit('input', value);
    },
    // RichSelectBox
    onClickItem(value: number) {
      const clickedIndex = this.selectList.findIndex((v) => v === value);
      if (clickedIndex > -1) { // 削除
        this.selectList.splice(clickedIndex, 1);
      } else { // 追加
        this.selectList.push(value);
      }
    },
    onClickAdd() {
      this.selectorshow = false;
      this.onSelectChange(this.selectList);
      this.selectList = [];
    },
    onClickCancel() {
      this.selectorshow = false;
      this.selectList = [];
    },
    onClickRemove(value: any) {
      this.$emit('remove', value);
    },
    closeSelect() {
      this.selectorshow = false;
    },
    handleClick() {
      // item.error が存在しない場合にのみイベントを発火
      if (!this.item.error) {
        this.$emit('resend');
      }
    },
    matchOptionText(text: string): string | null {
      return strFuzzyMatch(this.searchText, text);
    },
  },
});
